import type { BackendUser } from '../user/userService';

/** Managed customers pay before setup; legacy setup accounts keep their existing routing. */
export function customerOnboardingStage(user: BackendUser | null, isActive: boolean, impersonating = false): 'password' | 'payment' | null {
  if (!user?.managed_customer || user.role !== 'admin' || user.demoContext || impersonating) return null;
  if (user.must_set_password) return 'password';
  return isActive ? null : 'payment';
}

export function customerLandingPath(user: BackendUser | null, settings: string[], isActive: boolean, impersonating = false): string {
  const stage = customerOnboardingStage(user, isActive, impersonating);
  if (stage === 'password') return '/initial-password';
  if (stage === 'payment') return '/payment';
  if (settings.includes('account_setup') && !user?.demoContext) return '/setup';
  return isActive ? '/dashboard' : '/payment';
}
